import React, { useEffect, useRef, useState } from 'react';
import './PharmacyPaymentsForIP.css';
import axios from 'axios';
import ENDPOINTS, { API_BASE_URL } from '../../../Constants/ApiEndpoints';
import PharmacyReceipt from '../../../CommonComponents/Invoice Receipts/PharmacyReceipt';
import { dateTimeFormatter, dateTimeFormatter2 } from '../../../CommonComponents/Utils/DateTimeFormatter';

const PharmacyPaymentsForIP = ({ patient, prescriptionInvoices, loading, error }) => {

    console.log("PharmacyPaymentsForIP patient:", prescriptionInvoices);

    const [expandedInvoiceId, setExpandedInvoiceId] = useState(null);
    const [prescribedMedicines, setPrescribedMedicines] = useState([]);

    const [showPaymentComponent, setShowPaymentComponent] = useState(false);
    const [showRefundComponent, setShowRefundComponent] = useState(false);
    const [showInvoiceComponent, setShowInvoiceComponent] = useState(false);

    const [selectedInvoice, setSelectedInvoice] = useState(null);
    // For printing invoices BEGIN
    const [printInvoice, setPrintInvoice] = useState(null);
    const componentRef = useRef();

    useEffect(() => {
        if (printInvoice) {
            // Delay printing slightly to ensure DOM update
            setTimeout(() => {
                if (componentRef.current) {
                    window.print();
                    setPrintInvoice(null); // Close the print view after printing
                }
            }, 100);
        }
    }, [printInvoice]);

    // Add a function to trigger print with selected invoice
    const handlePrintClick = (invoice, e) => {
        e.stopPropagation(); // prevent row expand
        setPrintInvoice(invoice);
    };


    // For printing invoices END


    // // Fetch Invoices
    // const fetchPrescriptionInvoices = async () => {
    //     try {
    //         const response = await axios.get(ENDPOINTS.GET_PRESCRIPTION_INVOICES_OF_AN_ADMISSION, {
    //             params: { mrNumber: patient.mrNumber }
    //         });


    //         setprescriptionInvoices(response.data);
    //     } catch (err) {
    //         setError(err.message || "Failed to fetch invoices");
    //     }
    // };

    // // Fetch Prescribed Medicines
    // const fetchMedicines = async () => {
    //     try {
    //         const response = await axios.get(
    //             `${ENDPOINTS.GET_PRESCRIBED_MEDICINES_BY_PRESCRIPTIONID}/${patient.prescriptionId}`
    //         );
    //         setPrescribedMedicines(response.data);
    //     } catch (err) {
    //         setError(err.message || "Failed to fetch medicines");
    //     }
    // };

    // // useEffect to trigger both
    // useEffect(() => {
    //     setLoading(true);
    //     setError(null);

    //     Promise.all([prescriptionInvoices(),])
    //         .finally(() => setLoading(false));
    // }, [patient.admissionId]);


    const toggleInvoice = (invoiceId) => {
        setExpandedInvoiceId(prev => (prev === invoiceId ? null : invoiceId));
    };

    if (loading) return <p>Loading invoices...</p>;
    if (error) return <p>Error: {error}</p>;

    const renderInvoice = (inv) => (
        <>
            <div
                className="invoice-row"
                onClick={() => toggleInvoice(inv.invoiceId)}
                style={{ cursor: 'pointer' }}
            >
                <div className="invoice-left">
                    <span className="invoice-number">Invoice #{inv.invoiceId}</span>
                    <span className="invoice-name">({inv.name || "Patient"})</span>
                </div>
                <div className="invoice-status">{inv.invoiceStatus}</div>
                <div className="invoice-right">
                    <span className="invoice-amount">₹{inv.totalAmount}</span>
                    <button className="icon-btn" title="Print" onClick={(e) => handlePrintClick(inv, e)}>🖨️</button>
                    <button className="icon-btn">➕</button>
                </div>
            </div>



            {expandedInvoiceId === inv.invoiceId && (
                <div className="invoice-details">
                    <p><strong>Date: </strong>{dateTimeFormatter2(inv.invoiceTime)}</p>

                    <table className="details-table">
                        <thead>
                            <tr>
                                <th>S.no</th>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Expiry</th>
                                <th>Batch</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {inv.prescribedMedicines?.length > 0 ? (
                                inv.prescribedMedicines.map((med, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{(med.medicineBrand || '') + (med.composition ? ` (${med.composition})` : '')}</td>
                                        <td>{med.quantity}</td>
                                        <td>{med.expiryDate || '-'}</td>
                                        <td>{med.batchNumber || '-'}</td>
                                        <td>₹{med.price}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: 'center' }}>
                                        No medicines prescribed
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <div className="summary-box">
                        <div className="payment-line">
                            {inv.payments && inv.payments.map((pmt, i) => (
                                <div key={i}>
                                    <strong>{pmt.paymentId}</strong> ₹{pmt.amount} ({pmt.paymentMode}) Received By <strong>{inv.receivedBy || "Staff"}</strong> at {dateTimeFormatter2(new Date(pmt.paymentDate).toLocaleString())}
                                </div>
                            ))}
                        </div>

                        <div className="amount-summary">
                            <div className="summary-row">
                                <span>Total Amount:</span>
                                <span>₹{inv.totalAmount}</span>
                            </div>
                            <div className="summary-row">
                                <span>Paid Amount:</span>
                                <span>₹{inv.amountPaid}</span>
                            </div>
                            <div className="summary-row">
                                <span>Due:</span>
                                <span>₹{inv.totalAmount - inv.amountPaid}</span>
                            </div>
                        </div>
                    </div>
                    <button className="cancel-btn" onClick={() => setExpandedInvoiceId(null)}>Collapse</button>
                </div>
            )}

        </>
    );



    return (
        <div className="payment-history-container">
            {/* <h2 className="payment-title"> </h2>

            <div className="payment-header-row">
                <h3 className="payment-subheading"></h3>
                <div className="payment-actions">

                    <button className="action-btn">🖨️ Print All</button>
                </div>
            </div> */}

            <div className="invoice-list">

                {/* 🔴 Pending Invoices 🚨*/}
                <h2 className="payment-title">Pharmacy Pending Payments</h2>
                <div className="payment-actions">
                    <button className="action-btn" onClick={(e) => handlePrintClick(prescriptionInvoices[0] || {}, e)}>🖨️ Print All</button>
                </div>
                {prescriptionInvoices.filter(inv => inv.invoiceStatus !== 'PAID').length === 0 ? (
                    <p style={{ marginLeft: '1rem' }}>No pending invoices.</p>
                ) : (
                    prescriptionInvoices.filter(inv => inv.invoiceStatus !== 'PAID').map((inv, idx) => (
                        <div key={`pending-${idx}`}>
                            {renderInvoice(inv)}
                        </div>
                    ))
                )}

                {/* ✅ Completed Invoices */}
                <h2 className="payment-title">Pharmacy Completed Payments</h2>
                {prescriptionInvoices.filter(inv => inv.invoiceStatus === 'PAID').length === 0 ? (
                    <p style={{ marginLeft: '1rem' }}>No completed invoices.</p>
                ) : (
                    prescriptionInvoices.filter(inv => inv.invoiceStatus === 'PAID').map((inv, idx) => (
                        <div key={`completed-${idx}`}>
                            {renderInvoice(inv)}
                        </div>
                    ))
                )}

                {printInvoice && (
                    <div className="print-area">
                        <PharmacyReceipt
                            ref={componentRef}
                            invoice={printInvoice}
                            patient={patient}
                            prescribedMedicines={printInvoice.prescribedMedicines}
                        />
                    </div>
                )}

            </div>

        </div>
    );
};

export default PharmacyPaymentsForIP;
